import { PureComponent } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { getName } from './utils';

type Props = {
  intl: IntlShape;
  user: BB.UserType | null | undefined;
};

class UserName extends PureComponent<Props> {
  render() {
    return getName(this.props.user, this.props.intl);
  }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(UserName);
